module.exports = __webpack_public_path__ + "static/media/What_is_an_embedded_system.341e8009.png";